import produce from 'immer';
import * as types from './constants';

export const initialState = {
  loading: false,
  error: false,
  certificates: [],
  total: 0,
  pageSize: 20,
  pageNumber: 1,
  search: '',
  columns: [],
  gridName: '',
  certificateData: null,
  loadingDetail: false,
  statusDelete: 'idle',
  cachedImagesVersion: {},

  associatedProducts: {
    loading: false,
    pageIndex: 1,
    pageSize: 20,
    totalItems: 0,
    data: [],
    columns: [],
    memberId: null,
  },

  editTypeLoading: false,
  isDisplayCertificateNew: false,
  cachedFromDate: null,
};

const certificateReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {

      case types.SHOW_LOADING:
        draft.loading = true;
        break;

      case types.GET_CERTIFICATE_LIST:
        draft.loading = true;
        draft.error = false;
        draft.pageSize = action.pageSize;
        // Do not set pageNumber here — wait for successful response to set 1-based pageNumber
        // This prevents the UI from briefly showing page 0 while the request is in-flight.
        draft.search = action.search;
        break;

      case types.GET_CERTIFICATE_LIST_SUCCESS:
        draft.loading = false;
        draft.certificates = action.certificates;
        draft.total = action.total;
        draft.statusDelete = 'idle';
        // update pagination from response (action.pageIndex is 1-based from saga normalize)
        if (typeof action.pageIndex !== 'undefined') {
          draft.pageNumber = action.pageIndex;
        }
        if (typeof action.pageSize !== 'undefined') {
          draft.pageSize = action.pageSize;
        }
        break;

      case types.GET_CERTIFICATE_LIST_ERROR:
        draft.loading = false;
        draft.total = 0;
        draft.certificates = [];
        draft.error = action.error;
        draft.statusDelete = 'idle';
        break;

      // Short Detail
      case types.GET_CERTIFICATE_SHORT_DETAIL:
        draft.loadingDetail = true;
        draft.error = false;
        break;

      case types.GET_CERTIFICATE_SHORT_DETAIL_SUCCESS:
        draft.loadingDetail = false;
        draft.certificateData = action.data;
        break;

      case types.GET_CERTIFICATE_SHORT_DETAIL_ERROR:
        draft.loadingDetail = false;
        draft.error = action.error;
        break;

      // Associations (Certificates For Member)
      case types.GET_PRODUCTS_FOR_CERTIFICATES:
        draft.associatedProducts.loading = true;
        break;

      case types.GET_PRODUCTS_FOR_CERTIFICATES_SUCCESS:
        draft.associatedProducts.loading = false;
        // be defensive: action.data or action.data.paging may be undefined depending on API response
        draft.associatedProducts.data = action.data?.gridData || [];
        const paging = action.data?.paging || {};
        draft.associatedProducts.pageIndex = paging.currentPageIndex || draft.associatedProducts.pageIndex;
        draft.associatedProducts.pageSize = paging.currentPageSize || draft.associatedProducts.pageSize;
        draft.associatedProducts.totalItems = paging.totalRecord || draft.associatedProducts.totalItems;
        break;

      case types.GET_COLUMNS_CERTIFICATES_FOR_MEMBER_SUCCESS:
        draft.associatedProducts.columns = action.columns;
        break;

      case types.SAVE_ID_MEMBER:
        draft.associatedProducts.memberId = action.id;
        break;

      case types.UPDATE_CERTIFICATE_TYPE_PANE:
        draft.editTypeLoading = true;
        break;

      case types.UPDATE_CERTIFICATE_TYPE_PANE_SUCCESS:
        draft.editTypeLoading = false;
        break;

      case types.UPDATE_CERTIFICATE_TYPE_PANE_ERROR:
        draft.editTypeLoading = false;
        break;

      case types.TOGGLE_CERTIFICATE_NEW:
        draft.isDisplayCertificateNew = action.isDisplayCertificateNew;
        break;

      case types.CACHE_CERTIFICATE_FROM_DATE:
        draft.cachedFromDate = action.fromDate;
        break;

      case types.CERTIFICATE_GRID_COLUMN_INFO:
        draft.loading = true;
        draft.error = false;
        draft.gridName = action.gridName;
        break;

      case types.CERTIFICATE_GRID_COLUMN_INFO_SUCCESS:
        draft.loading = false;
        draft.columns = action.columns;
        break;

      case types.CERTIFICATE_GRID_COLUMN_INFO_ERROR:
        draft.loading = false;
        draft.error = action.error;
        break;

      case types.GET_CERTIFICATE_DETAIL_GRID:
        draft.loading = true;
        draft.error = false;
        break;

      case types.GET_CERTIFICATE_DETAIL_GRID_SUCCESS:
        draft.loading = false;
        draft.certificateGridData = action.data;
        draft.totalRecords = action.total;
        break;

      case types.GET_CERTIFICATE_DETAIL_GRID_ERROR:
        draft.loading = false;
        draft.error = action.error;
        break;

      case types.GET_CERTIFICATE_FULL_DETAIL:
        draft.loadingDetail = true;
        draft.error = false;
        break;

      case types.GET_CERTIFICATE_FULL_DETAIL_SUCCESS:
        draft.loadingDetail = false;
        draft.certificateData = action.data;
        break;

    }
  });

export default certificateReducer;
